import PropTypes from 'prop-types'
import React from 'react'

import assetsPath from '../../../common/utils/assetsPath'
import headerLayoutConfig from '../../../config/layout/header'
import HeaderEnvatoProducts from './header/envatoProducts'
import HeaderAdminLink from './header/adminLink'
import HeaderCart from './header/cart'
import HeaderUserMenu from './header/userMenu'

import styles from './globalHeader.module.css'

class GlobalHeader extends React.Component {
  static propTypes = {
    currentSite: PropTypes.string.isRequired,
    user: PropTypes.object
  }

  render () {
    const { staticLinks, envatoProducts, envatoProductsStaticLinks } = headerLayoutConfig
    const { user, currentSite } = this.props

    return (
      <div className={styles.header}>
        <div className={styles.gridWide}>
          <div className={styles.wrapper}>
            <a href='https://market.envato.com'>
              <img className={styles.logo}
                alt='Envato Market'
                src={`${assetsPath()}/images/logo-envato-market.svg`} />
            </a>

            <nav className={styles.menu} role='navigation' data-test-selector='global-header-wrapper'>
              <ul className={styles.menuList}>
                <HeaderAdminLink user={user} />

                {
                  staticLinks.map((staticLink) => {
                    return (
                      <li key={staticLink.label}
                        className={styles.menuItem}>
                        <a href={staticLink.url}
                          className={styles.menuLink}>
                          <span className={styles.menuText}>
                            {staticLink.label}
                          </span>
                        </a>
                      </li>
                    )
                  })
                }

                <HeaderEnvatoProducts envatoProducts={envatoProducts} envatoProductsStaticLinks={envatoProductsStaticLinks} />

                <HeaderCart user={user} />

                <HeaderUserMenu
                  user={user}
                  currentSite={currentSite}
                />
              </ul>
            </nav>
          </div>
        </div>
      </div>
    )
  }
}

export default GlobalHeader



// WEBPACK FOOTER //
// ./client/components/siteHeader/globalHeader.js